export const DefaultFastlyQueryScope = "fastly-cache";
